import React, { Component } from "react";
import Select from "react-select";
import $, { event } from "jquery";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { adminlimit, downloadUrl, s3Link } from "../../Settings/Config";
import api from "../../../utils/axios";
import { showContaimerLoader, encodeValue, removeItem, showPageCount, removeChar, isEmpty, showLoader, hideLoader, showAlert, hasPermission } from "../../Settings/Settings";
import Pagenation from "../../Layout/Pagenation";
const module = "candidatebank";
const modulePath = "/candidate";
const moduleName = "Bank Details";
const moduleID = 22;
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLimit: { label: adminlimit, value: adminlimit },
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      status: "",
      editID: "",
      postdata: {
        avoidBankDetails: false,
        bank_name: "",
        account_num: "",
        beneficiary: "",
        beneficiary_addr: "",
        bank_addr: "",
        branch: "",
        types: { label: "General", value: "general" },
        ifsc_code: "",
        swift_code: "",
        pan_num: "",
        passbook: "",
        pan_card: "",
        aadharNumber: "",
        aadharCard: "",
        aadharPanLinked: "",
      },
      detaildata: [],
      viewDocumentTitle: "",
      viewDocumentFile: "",
      viewfileType: "",
      restForm: false,
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadList(1);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_bank_frm");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
  }
  searchList(e) {
    e.preventDefault();
    this.setState({ loading: true, currentPage: 1 }, () => {
      this.loadList(1);
    });
  }
  resetSearch(e) {
    e.preventDefault();
    this.setState(
      {
        loading: true,
        name: "",
        status: "",
        currentPage: 1,
      },
      () => {
        this.loadList(1);
      },
    );
  }
  loadList(offset) {
    this.setState({ loading: true });
    let addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (this.state.status !== null && Object.keys(this.state.status).length > 0) {
      addParams += "&status=" + this.state.status.value;
    }
    try {
      api
        .get(`${module}?limit=${this.state.pageLimit.value}&offset=${offset}&candidateId=${this.props.candidateID}${addParams}`)
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ listdata: res.data.result, loading: false, totalRecords: res.data.totalRecords, totalPage: res.data.totalPages });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
        });
    } catch (e) {
      this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
    }
  }
  edit(editID, e) {
    e.preventDefault();
    this.setState({ editID: editID }, () => {
      api
        .get(`${module}/detail/${encodeValue(editID)}`)
        .then((res) => {
          if (res.data.status === "ok") {
            $("#addNewBank").trigger("click");
            const result = res.data.result;
            const types = result?.types || "general";
            let typeLabel = "";
            if (types === "general") {
              typeLabel = "General";
            } else if (types === "nri") {
              typeLabel = "NRI";
            }
            const avoidBankDetails = result.avoidBankDetails || "";
            this.setState({
              postdata: {
                avoidBankDetails: avoidBankDetails === "Y" ? true : false,
                bank_name: result.bank_name || "",
                account_num: result.account_num || "",
                beneficiary: result.beneficiary || "",
                beneficiary_addr: result.beneficiary_addr || "",
                bank_addr: result.bank_addr || "",
                branch: result.branch || "",
                types: { label: typeLabel, value: types },
                ifsc_code: result.ifsc_code || "",
                swift_code: result.swift_code || "",
                pan_num: result.pan_num || "",
                passbook: result.passbook !== "" && result.passbook !== null ? `${downloadUrl}views/public/bank_details/${result.passbook}` : "",
                pan_card: result.pan_card !== null && result.pan_card !== "" ? `${downloadUrl}views/public/pan_card/${result.pan_card}` : "",
                aadharNumber: result.aadharNumber || "",
                aadharCard: result.aadharCard !== null && result.aadharCard !== "" ? `${s3Link}bank/${result.aadharCard}` : "",
                aadharPanLinked: result.aadharPanLinked !== null && result.aadharPanLinked !== "" ? `${s3Link}bank/${result.aadharPanLinked}` : "",
              },
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        () => {
          this.loadList(value);
        },
      );
    } else if (field === "pageLimit") {
      this.setState({ pageLimit: value, currentPage: 1 }, () => {
        this.loadList(1);
      });
    } else if (field === "restForm") {
      this.setState({ restForm: value });
    }
  };
  handleChangeText(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, this.sateValChange, this.state.currentPage);
  }
  saveDocument() {}

  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader("submit_bank_frm");
    const postData = this.state.postdata;

    const postObject = {
      candidateId: this.props.candidateID,
      avoidBankDetails: postData.avoidBankDetails === true ? "Y" : "N",
      bank_name: postData.bank_name.toUpperCase(),
      account_num: postData.account_num.toUpperCase(),
      beneficiary: postData.beneficiary.toUpperCase(),
      beneficiary_addr: postData.beneficiary_addr.toUpperCase(),
      bank_addr: postData.bank_addr.toUpperCase(),
      branch: postData.branch.toUpperCase(),
      ifsc_code: postData.ifsc_code.toUpperCase(),
      types: postData.types?.value ?? "general",
      swift_code: postData.swift_code.toUpperCase(),
      pan_num: postData.pan_num.toUpperCase(),
      aadharNumber: postData.aadharNumber || "",
    };

    const formPayload = new FormData();
    let error = "";
    const fileInput = document.getElementById("passbook");
    const file = fileInput?.files?.[0];
    if (file) {
      if (file.type !== "application/pdf") {
        error += "Passbook/Cancelled Cheque PDF only allowed";
      } else {
        formPayload.append("passbook", file);
      }
    }

    const fileInputpan_card = document.getElementById("pan_card");
    const filepan_card = fileInputpan_card?.files?.[0];
    if (filepan_card) {
      if (filepan_card.type !== "application/pdf") {
        error += "Pan Card PDF only allowed";
      } else {
        formPayload.append("pan_card", filepan_card);
      }
    }

    const fileInputaadharCard = document.getElementById("aadharCard");
    const fileaadharCard = fileInputaadharCard?.files?.[0];
    if (fileaadharCard) {
      if (fileaadharCard.type !== "application/pdf") {
        error += "Pan Card PDF only allowed";
      } else {
        formPayload.append("aadharCard", fileaadharCard);
      }
    }

    const fileInputaadharPanLinked = document.getElementById("aadharPanLinked");
    const fileaadharPanLinked = fileInputaadharPanLinked?.files?.[0];
    if (fileaadharPanLinked) {
      if (fileaadharPanLinked.type !== "application/pdf") {
        error += "Pan Card PDF only allowed";
      } else {
        formPayload.append("aadharPanLinked", fileaadharPanLinked);
      }
    }

    if (error !== "") {
      showAlert("Error", error, "error");
      return false;
    }
    Object.keys(postObject).forEach((key) => {
      formPayload.append(key, postObject[key]);
    });

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${encodeValue(this.state.editID)}`;
      method = "put";
    }
    api[method](post_url, formPayload)
      .then((res) => {
        hideLoader("submit_bank_frm");
        $(".btn-close").trigger("click");
        const errMsg = res.data.message;
        if (res.data.status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.loadList(1);
          this.resetFrom();
        }
      })
      .catch((err) => {
        hideLoader("submit_bank_frm");
        const errMsg = err.response.data?.message || err?.message;
        showAlert("Error", errMsg, "error", "No");
        console.error(err);
      });
  };
  viewFile(viewDocumentFile, viewfileType, viewDocumentTitle, e) {
    e.preventDefault();
    let link = '';
    if(viewfileType === "aadharCard" || viewfileType === "aadharPanLinked") {
      link = viewDocumentFile;
    }else  {
       link = `${downloadUrl}views/public/${viewfileType === "passbook" ? "bank_details" : "pan_card"}/${viewDocumentFile}`
    }
     window.open(link, '_blank');
    /* this.setState({ viewDocumentFile, viewDocumentTitle, viewfileType }, () => {
      $("#addNewBank").trigger("click");
    }); */
  }
  closePopup() {
    this.setState({ viewDocumentFile: "", viewDocumentTitle: "" }, () => {
      this.resetFrom();
    });
  }
  resetFrom() {
    this.setState({
      editID: "",
      restForm: true,
      postdata: {
        avoidBankDetails: false,
        bank_name: "",
        account_num: "",
        beneficiary: "",
        beneficiary_addr: "",
        bank_addr: "",
        branch: "",
        types: { label: "General", value: "general" },
        ifsc_code: "",
        swift_code: "",
        pan_num: "",
        passbook: "",
        pan_card: "",
        aadharNumber: "",
        aadharCard: "",
        aadharPanLinked: "",
      },
    });
  }

  render() {
    return (
      <div className="main-container container-fluid mx-3">
        <div className="page-header">
          <h1 className="page-title">Bank Details</h1>
          <div>
            {hasPermission(moduleID, "add") && (
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <button className="btn btn-sm btn-success badge mx-4" type="button" data-bs-toggle="modal" data-bs-target="#bankmodal" data-backdrop="static" data-keyboard="false" id="addNewBank">
                    <i className="fa fa-plus"></i> Add New
                  </button>
                </li>
              </ol>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="form-row">
                  <div className="col-md-3">
                    <input type="text" className="form-control" placeholder={"Search keyword"} name="name" onChange={this.handleChangeText} value={this.state.name} />
                  </div>
                  <div className="col-md-3">
                    <a href="/" className="btn btn-primary" onClick={this.searchList.bind(this)}>
                      Search
                    </a>
                    <a href="/" className="btn btn-secondary offset-1" onClick={this.resetSearch.bind(this)}>
                      Reload
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              {this.state.loading ? (
                showContaimerLoader()
              ) : (
                <div>
                  <div className="card-header">
                    {parseInt(this.state.totalPage) > 0 && showPageCount(moduleName, this.state.currentPage, this.state.totalPage, this.state.totalRecords, this.sateValChange, this.state.pageLimit)}
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                        <thead className="table-primary">
                          <tr>
                            {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && <th className="text-center">Actions </th>}
                            <th>S.No.</th>
                            <th>Bank Name</th>
                            <th>Account Number</th>
                            <th>Bank Address</th>
                            <th>Branch</th>
                            <th>Type</th>
                            <th>Beneficiary Name</th>
                            <th>Beneficiary Address</th>
                            <th>IFSC Code</th>
                            <th>Swift Code</th>
                            <th>PAN Number</th>
                            <th>Passbook/Cancelled Cheque</th>
                            <td>Pan Card</td>
                            <td>AADHAAR Number</td>
                            <td>AADHAAR Card</td>
                            <td>AADHAAR & Pan Linked</td>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.listdata.length > 0 ? (
                            this.state.listdata.map((item, index) => {
                              return (
                                <tr key={index}>
                                  {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && (
                                    <td className="text-center text-nowrap" valign="top">
                                      {hasPermission(moduleID, "edit") && (
                                        <a href="/" onClick={this.edit.bind(this, item.id)} className="me-2">
                                          <i className="fa fa-pencil-square-o"></i>
                                        </a>
                                      )}
                                      {hasPermission(moduleID, "delete") && (
                                        <a href="/" className="delete_record" onClick={this.removeItem.bind(this, encodeValue(item.id))}>
                                          <i className="fa fa-trash"></i>
                                        </a>
                                      )}
                                    </td>
                                  )}
                                  <td>{(parseInt(this.state.currentPage) - 1) * parseInt(this.state.pageLimit.value) + (parseInt(index) + 1)}</td>
                                  <td>{item.bank_name}</td>
                                  <td>{item.account_num}</td>
                                  <td>{item.bank_addr}</td>
                                  <td>{item.branch}</td>
                                  <td>{item.types === "general" ? "General" : "NRI"}</td>
                                  <td>{item.beneficiary}</td>
                                  <td>{item.beneficiary_addr}</td>
                                  <td>{item.ifsc_code}</td>
                                  <td>{item.swift_code}</td>
                                  <td>{item.pan_num}</td>
                                  <td className="text-center">
                                    {item.passbook !== "" && item.passbook !== null && (
                                      <a href="/" onClick={this.viewFile.bind(this, item.passbook, "passbook", `${item.account_num}`)}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {item.pan_card !== "" && item.pan_card !== null && (
                                      <a href="/" onClick={this.viewFile.bind(this, item.pan_card, "pan_card", `${item.account_num}`)}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td>{item.aadharNumber}</td>
                                  <td className="text-center">
                                    {item.aadharCard !== "" && item.aadharCard !== null && (
                                      <a href="/" onClick={this.viewFile.bind(this, `${s3Link}bank/${item.aadharCard}`, "aadharCard", `${item.aadharNumber}`)}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {item.aadharPanLinked !== "" && item.aadharPanLinked !== null && (
                                      <a href="/" onClick={this.viewFile.bind(this, `${s3Link}bank/${item.aadharPanLinked}`, "aadharPanLinked", ``)}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td className="text-center" colSpan={14}>
                                No {moduleName} Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {parseInt(this.state.totalPage) > 1 && (
                      <Pagenation
                        params={{
                          totalRecords: this.state.totalRecords,
                          totalPage: this.state.totalPage,
                          currentPage: this.state.currentPage,
                        }}
                        sateValChange={this.sateValChange}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="modal fade" id="bankmodal" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{this.state.viewDocumentFile !== "" ? `View ${this.state.viewDocumentTitle}` : "Add New Document"}</h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              {this.state.viewDocumentFile !== "" ? (
                <div>
                  <iframe
                    src={
                      this.state.viewfileType === "aadharCard" || this.state.viewfileType === "aadharPanLinked"
                        ? this.state.viewDocumentFile
                        : `${downloadUrl}views/public/${this.state.viewfileType === "passbook" ? "bank_details" : "pan_card"}/${this.state.viewDocumentFile}`
                    }
                    width="100%"
                    height="500px"
                    title="View File"
                  ></iframe>
                  <div className="modal-footer">
                    <button className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                      Close
                    </button>
                  </div>
                </div>
              ) : (
                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  restForm={this.state.restForm}
                  sateValChange={this.sateValChange}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  closePopup={this.closePopup.bind(this)}
                  editID={this.state.editID}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default List;

const areSame = (types, currenField) => (types?.value === "general" && currenField === "" ? "This field is required." : null);

const isEmptyBank = (currenField, avoidBankDetails) => (currenField === "" && !avoidBankDetails ? "This field is required." : null);

const isEmptyBankIFSC = (currenField, avoidBankDetails, types) => (currenField === "" && !avoidBankDetails && types?.value==='general' ? "This field is required." : null);

const isEmptyIfsc = (types, currenField) => (types?.value === "general" && currenField === "" ? "This field is required." : null);

function validationConfig(props) {
  const { avoidBankDetails, bank_name, account_num, beneficiary, bank_addr, branch, passbook, types, ifsc_code, pan_num, pan_card, aadharNumber, aadharCard, aadharPanLinked } = props.fields;

  return {
    fields: [
      "avoidBankDetails",
      "bank_name",
      "account_num",
      "beneficiary",
      "bank_addr",
      "branch",
      "passbook",
      "types",
      "ifsc_code",
      "pan_num",
      "pan_card",
      "aadharNumber",
      "aadharCard",
      "aadharPanLinked",
    ],
    validations: {
      bank_name: [[isEmptyBank, bank_name, avoidBankDetails]],
      account_num: [[isEmptyBank, account_num, avoidBankDetails]],
      beneficiary: [[isEmptyBank, beneficiary, avoidBankDetails]],
      bank_addr: [[isEmptyBank, bank_addr, avoidBankDetails]],
      branch: [[isEmptyBank, branch, avoidBankDetails]],
      passbook: [[isEmptyBank, passbook, avoidBankDetails]],
      ifsc_code: [[isEmptyBankIFSC, ifsc_code, avoidBankDetails, types]],
      pan_num: {
        rules: [[areSame, types, pan_num]],
        fields: ["types", "pan_num"],
      },
      pan_card: {
        rules: [[areSame, types, pan_card]],
        fields: ["types", "pan_card"],
      },
      aadharNumber: {
        rules: [[areSame, types, aadharNumber]],
        fields: ["types", "aadharNumber"],
      },
      aadharCard: {
        rules: [[areSame, types, aadharCard]],
        fields: ["types", "aadharCard"],
      },
      aadharPanLinked: {
        rules: [[areSame, types, aadharPanLinked]],
        fields: ["types", "aadharPanLinked"],
      },
    },
  };
}
class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPDF: false,
      viewType: "",
      restData: false,
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.restForm === true) {
      this.props.sateValChange("restForm", false);
      setTimeout(() => {
        this.handleReset();
      }, 1000);
    }
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeCheckbox(name, e) {
    const { checked } = e.target;
    this.props.onChange(name, checked);
  }
  handleChangeFile(name, value) {
    this.props.onChange(name, value);
  }
  handleFileChange = (e) => {
    const file = e.target.files[0];
    const name = e.target.name;
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      this.props.onChange(name, previewUrl);
    }
  };
  viewFile(viewType, e) {
    e.preventDefault();
    let link = this.props.fields[viewType]
    window.open(link, '_blank');
   // this.setState({ showPDF: !this.state.showPDF, viewType });
  }
  closePopup() {
    this.props.sateValChange("restForm", true);
  }
  handleReset = () => {
    const { $validation } = this.props;
    // 2️⃣ Reset all validation errors
    Object.keys($validation).forEach((key) => {
      if ($validation[key]) {
        $validation[key].show = false;
        $validation[key].error = {};
      }
    });
    this.setState({ restData: this.state.restData });
  };

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgbank_name,
      errMsgaccount_num,
      errMsgbeneficiary,
      errMsgbank_addr,
      errMsgbranch,
      errMsgpassbook,
      errMsgifsc_code,
      errMsgpan_num,
      errMsgaadharNumber,
      errMsgpan_card,
      errMsgaadharCard,
      errMsgaadharPanLinked = "";
    if ($validation.bank_name.error.reason !== undefined) {
      errMsgbank_name = $validation.bank_name.show && <span className="error">{$validation.bank_name.error.reason}</span>;
    }
    if ($validation.account_num.error.reason !== undefined) {
      errMsgaccount_num = $validation.account_num.show && <span className="error">{$validation.account_num.error.reason}</span>;
    }
    if ($validation.beneficiary.error.reason !== undefined) {
      errMsgbeneficiary = $validation.beneficiary.show && <span className="error">{$validation.beneficiary.error.reason}</span>;
    }
    if ($validation.bank_addr.error.reason !== undefined) {
      errMsgbank_addr = $validation.bank_addr.show && <span className="error">{$validation.bank_addr.error.reason}</span>;
    }
    if ($validation.branch.error.reason !== undefined) {
      errMsgbranch = $validation.branch.show && <span className="error">{$validation.branch.error.reason}</span>;
    }
    if ($validation.ifsc_code.error.reason !== undefined) {
      errMsgifsc_code = $validation.ifsc_code.show && <span className="error">{$validation.ifsc_code.error.reason}</span>;
    }
    if ($validation.pan_num.error.reason !== undefined) {
      errMsgpan_num = $validation.pan_num.show && <span className="error">{$validation.pan_num.error.reason}</span>;
    }
    if ($validation.passbook.error.reason !== undefined) {
      errMsgpassbook = $validation.passbook.show && <span className="error">{$validation.passbook.error.reason}</span>;
    }
    if ($validation.aadharNumber.error.reason !== undefined) {
      errMsgaadharNumber = $validation.aadharNumber.show && <span className="error">{$validation.aadharNumber.error.reason}</span>;
    }
    if ($validation.pan_card.error.reason !== undefined) {
      errMsgpan_card = $validation.pan_card.show && <span className="error">{$validation.pan_card.error.reason}</span>;
    }
    if ($validation.aadharCard.error.reason !== undefined) {
      errMsgaadharCard = $validation.aadharCard.show && <span className="error">{$validation.aadharCard.error.reason}</span>;
    }
    if ($validation.aadharPanLinked.error.reason !== undefined) {
      errMsgaadharPanLinked = $validation.aadharPanLinked.show && <span className="error">{$validation.aadharPanLinked.error.reason}</span>;
    }

    return (
      <>
        <div style={{ display: !this.state.showPDF ? "none" : "" }}>
          {this.state.showPDF && this.state.viewType !== "" && <iframe src={`${fields[this.state.viewType]}`} width="100%" height="500px" title="View File"></iframe>}
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={this.viewFile.bind(this, "")}>
              Back
            </button>
          </div>
        </div>
        <div style={{ display: this.state.showPDF ? "none" : "" }}>
          <div className="modal-body">
            <div className="form-group">
              <div className="form-row">
                <div class="col-xl-2 col-md-2">
                  <div class="form-group mt-6">
                    <div class="custom-controls-stacked">
                      <label class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          name="avoidBankDetails"
                          onChange={this.handleChangeCheckbox.bind(this, "avoidBankDetails")}
                          checked={fields.avoidBankDetails}
                        />
                        <span class="custom-control-label">Avoid Bank Details</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Account Number{!fields.avoidBankDetails && <span className="lbl-error">*</span>}</label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Account Number"
                    name="account_num"
                    value={fields.account_num}
                    {...$field("account_num", (e) => onChange("account_num", e.target.value))}
                  />
                  {errMsgaccount_num}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Beneficiary Name{!fields.avoidBankDetails && <span className="lbl-error">*</span>}</label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Beneficiary Name"
                    name="beneficiary"
                    value={fields.beneficiary}
                    {...$field("beneficiary", (e) => onChange("beneficiary", e.target.value))}
                  />
                  {errMsgbeneficiary}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Beneficiary Address</label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Beneficiary Address"
                    name="beneficiary_addr"
                    value={fields.beneficiary_addr}
                    {...$field("beneficiary_addr", (e) => onChange("beneficiary_addr", e.target.value))}
                  />
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Bank Name{!fields.avoidBankDetails && <span className="lbl-error">*</span>}</label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Bank Name"
                    name="bank_name"
                    value={fields.bank_name}
                    {...$field("bank_name", (e) => onChange("bank_name", e.target.value))}
                  />
                  {errMsgbank_name}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Bank Address{!fields.avoidBankDetails && <span className="lbl-error">*</span>}</label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Bank Address"
                    name="bank_addr"
                    value={fields.bank_addr}
                    {...$field("bank_addr", (e) => onChange("bank_addr", e.target.value))}
                  />
                  {errMsgbank_addr}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Branch Name{!fields.avoidBankDetails && <span className="lbl-error">*</span>}</label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Branch Name"
                    name="branch"
                    value={fields.branch}
                    {...$field("branch", (e) => onChange("branch", e.target.value))}
                  />
                  {errMsgbranch}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Type<span className="lbl-error">*</span>
                  </label>
                  <Select
                    value={fields.types}
                    onChange={this.handleSelectChange.bind(this, "types")}
                    placeholder="Select Type"
                    options={[
                      { label: "General", value: "general" },
                      { label: "NRI", value: "nri" },
                    ]}
                  />
                </div>
                {fields.types?.value === "general" && (
                  <>
                    <div className="form-group col-md-3">
                      <label className="form-label">IFSC Code{!fields.avoidBankDetails && <span className="lbl-error">*</span>}</label>
                      <input
                        type="text"
                        className="form-control upper-case"
                        placeholder="IFSC Code"
                        name="ifsc_code"
                        value={fields.ifsc_code}
                        {...$field("ifsc_code", (e) => onChange("ifsc_code", e.target.value))}
                      />
                      {errMsgifsc_code}
                    </div>
                  </>
                )}
                {fields.types?.value === "nri" && (
                  <div className="form-group col-md-3">
                    <label className="form-label">
                      Swift Code<span className="lbl-error">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Swift Code"
                      name="swift_code"
                      value={fields.swift_code}
                      {...$field("swift_code", (e) => onChange("swift_code", e.target.value))}
                    />
                  </div>
                )}

                <div class="col-md-3">
                  <div class="border rounded">
                    <h6 class="mb-3">
                      Passbook/Cancelled Cheque<span className="lbl-error">*</span>
                    </h6>
                    <input type="file" class="form-control mb-3" ype="file" name="passbook" id="passbook" accept="application/pdf" onChange={this.handleFileChange} />
                    {errMsgpassbook}
                    {fields.passbook !== "" && (
                      <a href="/" onClick={this.viewFile.bind(this, "passbook")}>
                        <button class="btn btn-outline-secondary btn-sm ms-2">View</button>
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <h2 class="display-8" style={{ marginBottom: "0", fontWeight: "bold", borderBottom: "1px solid #CCC", paddingBottom: "6px" }}>
                Pan Details
              </h2>
              <div className="form-row">
                {fields.types?.value === "general" && (
                  <div className="form-group col-md-3">
                    <label className="form-label">
                      Pan Number<span className="lbl-error">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Pan Number"
                      name="pan_num"
                      value={fields.pan_num}
                      {...$field("pan_num", (e) => onChange("pan_num", e.target.value))}
                    />
                    {errMsgpan_num}
                  </div>
                )}

                <div class="col-md-3">
                  <div class="border rounded">
                    <h6 class="mb-3">
                      Pan Card<span className="lbl-error">*</span>
                    </h6>
                    <input type="file" class="form-control mb-3" name="pan_card" id="pan_card" accept="application/pdf" onChange={this.handleFileChange} />
                    {errMsgpan_card}
                    {fields.pan_card !== "" && (
                      <a href="/" onClick={this.viewFile.bind(this, "pan_card")}>
                        <button class="btn btn-outline-secondary btn-sm ms-2">View</button>
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <h2 class="display-8" style={{ marginBottom: "0", fontWeight: "bold", borderBottom: "1px solid #CCC", paddingBottom: "6px" }}>
                AADHAAR Details
              </h2>
              <div className="form-row">
                {fields.types?.value === "general" && (
                  <div className="form-group col-md-3">
                    <label className="form-label">
                      AADHAAR NUMBER<span className="lbl-error">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="AADHAAR NUMBER"
                      name="aadharNumber"
                      value={fields.aadharNumber}
                      {...$field("aadharNumber", (e) => onChange("aadharNumber", e.target.value))}
                    />
                    {errMsgaadharNumber}
                  </div>
                )}

                <div class="col-md-3">
                  <div class="border rounded">
                    <h6 class="mb-3">
                      AADHAAR CARD<span className="lbl-error">*</span>
                    </h6>
                    <input type="file" class="form-control mb-3" name="aadharCard" id="aadharCard" accept="application/pdf" onChange={this.handleFileChange} />
                    {errMsgaadharCard}
                    {fields.aadharCard !== "" && (
                      <a href="/" onClick={this.viewFile.bind(this, "aadharCard")}>
                        <button class="btn btn-outline-secondary btn-sm ms-2">View</button>
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div class="col-md-3">
                  <div class="border rounded">
                    <h6 class="mb-3">
                      Aadhaar Card & Pan Card Linked<span className="lbl-error">*</span>
                    </h6>
                    <input type="file" class="form-control mb-3" name="aadharPanLinked" id="aadharPanLinked" accept="application/pdf" onChange={this.handleFileChange} />
                    {errMsgaadharPanLinked}
                    {fields.aadharPanLinked !== "" && (
                      <a href="/" onClick={this.viewFile.bind(this, "aadharPanLinked")}>
                        <button class="btn btn-outline-secondary btn-sm ms-2">View</button>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.closePopup.bind(this)}>
              Close
            </button>
            <button
              className="btn btn-primary"
              id="submit_bank_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Save changes
            </button>
          </div>
        </div>
      </>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
